import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import priceFormatter from "@/utility/priceFormatter";
import Variable from "../Variable.vue";
export default Vue.extend({
    components: { Variable },
    props: {
        salaryRow: {},
        salaryRowDetails: {},
    },
    data() {
        return {
            headers: [
                {
                    text: "Calculation basis",
                    value: "description",
                    sortable: false,
                },
                {
                    text: "Value",
                    value: "value",
                    align: "right",
                    sortable: false,
                },
            ],
        };
    },
    filters: {},
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
        toSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK() || 0;
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        items() {
            return [
                {
                    description: "Additions",
                    value: this.toSek(this.salaryRow.additions),
                },
                {
                    description: "Benefit month",
                    value: this.salaryRowDetails.benefitMonth,
                },
                {
                    description: "Goal achivement",
                    value: this.salaryRowDetails.goalAchivement,
                },
                {
                    description: "Target sales",
                    value: this.salaryRowDetails.monthlyTargetSales,
                },
                {
                    description: "Outstanding salary",
                    value: this.salaryRowDetails.outstandingSalary,
                },
                {
                    description: "Sales",
                    value: this.salaryRowDetails.sales,
                },
                {
                    description: "Sales achivement",
                    value: this.salaryRowDetails.salesAchivement,
                },
                {
                    description: "Stack CMR1",
                    value: this.salaryRowDetails.stackCmr1,
                },
                {
                    description: "Stack revenue",
                    value: this.salaryRowDetails.stackTotalSalesRevenue,
                },
                {
                    description: "Variable cost",
                    value: this.salaryRowDetails.totalVariableCost,
                },
                {
                    description: "Stack salary",
                    value: this.salaryRowDetails.stackSalary,
                },
            ];
        },
    },
});
